import React from 'react';
import { useLocationsStore } from '../../../hooks/useLocationsStore';
import { shallow } from 'zustand/shallow';
import Select from 'react-select';
import { Control, RegisterOptions, Controller } from 'react-hook-form';

interface LocationSelectorProps {
  control: Control<any>;
  name: string;
  rules: RegisterOptions;
  className?: string;
}

function LocationSelector(props: LocationSelectorProps) {
  const { allLocations, status } = useLocationsStore(
    state => ({ allLocations: state.allLocations, status: state.status }),
    shallow
  );

  const options = React.useMemo(() => {
    return allLocations.map(option => ({
      label: option.name,
      value: option.id,
    }));
  }, [allLocations]); // Fixed dependency - use allLocations directly

  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      render={({ field, formState: { errors, isSubmitSuccessful } }) => (
        <>
          <Select
            {...field}
            ref={ref => {
              if (isSubmitSuccessful) {
                ref?.clearValue();
              }
            }}
            menuPlacement="auto"
            menuPortalTarget={document.body}
            isLoading={status === 'loading'}
            options={options}
            className="users-admin-container__form-field-select"
            styles={{
              menuPortal: base => ({ ...base, zIndex: 9999 }),
              control: base => ({
                ...base,
                minHeight: '32px', // Reduced from 36px
                height: '32px',
              }),
              valueContainer: base => ({
                ...base,
                height: '32px',
                padding: '0 6px', // Reduced padding
              }),
              input: base => ({
                ...base,
                margin: '0',
                padding: '0',
              }),
              indicatorsContainer: base => ({
                ...base,
                height: '32px',
              }),
              dropdownIndicator: base => ({
                ...base,
                padding: '4px', // Smaller dropdown arrow container
              }),
              clearIndicator: base => ({
                ...base,
                padding: '4px', // Smaller clear button
              }),
              menu: base => ({
                ...base,
                maxHeight: '130px', // Reduced menu height for modals
              }),
              menuList: base => ({
                ...base,
                maxHeight: '130px',
              }),
              option: (base, state) => ({
                ...base,
                padding: '6px 12px', // Compact option padding
                fontSize: '14px', // Slightly smaller font
              }),
            }}
          />
          {errors[props.name] && (
            <p style={{ color: 'red', margin: '4px 0 0 0', fontSize: '12px' }}>
              {(errors[props.name]!.message as string) ?? 'Required'}
            </p>
          )}
        </>
      )}
    />
  );
}

export default LocationSelector;
